import * as React from "react";
import { UserFilterSettingsModel, UserModel } from "../../models/user/";
import UserService from '../../services/userService';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import Spinner from '../../common/components/spinner/spinner';
import { UserFilter } from './userFilter';
import UserList from './userList';
import UserAddEditDialog from './userAddEditDialog';
import Translate from "../../common/functions/translate";
import Snackbar from "../../common/components/snackbar/snackbar";
import Button from "@material-ui/core/Button";

interface IProps {
}

interface IState {
  isLoading: boolean;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  userSettings: UserFilterSettingsModel
  users: Array<UserModel>;
  currentUser: UserModel;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
}

const initFrom = 0;
const numberOfRows = 10;

class UserContainer extends React.Component<IProps, IState> {
  snackbar: any;
  userService = new UserService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      validationMessage: '',
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      users: new Array<UserModel>(0),
      currentUser: new UserModel(),
      userSettings: new UserFilterSettingsModel(),
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
    };
  }

  // events
  componentDidMount() {
    this.getAllUsers(this.state.from, this.state.numberOfRows);
  }


  getAllUsers(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.userService.getAllUsers(from, numberOfRows, this.state.userSettings).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          from: from,
          users: data.users,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }


  // handles
  handleAddAndEditClick = id => {
    if (!id) { // Add			
      this.setCurrentUser(new UserModel());
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.userService.getUser(id)
        .then(
          (data: UserModel) => {
            this.setCurrentUser(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          })
        .catch(error => {
          this.snackbar.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
    }
  };

  getUser = (id) => {
    this.userService.getUser(id)
      .then(
        (data: UserModel) => {
          this.setCurrentUser(data);
          this.setState({
            isLoading: false
          });
        })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleDeleteClick = (id, e) => {
    e.stopPropagation();
    this.getUser(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteUser(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.userService.deleteUser(id)
      .then(
        data => {
          this.snackbar.show({ severity: 'success', summary: Translate('Deleted Successfully') });
          this.getAllUsers(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleSaveButton = (user: UserModel) => {
    this.setState({
      isLoading: true
    });

    if (!user.userId) { // Add
      this.userService.addUser(user)
        .then(
          (data) => {
            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setState({ isLoading: false })
            this.handleCloseAddEditUserModal();
          },
          error => {
            this.snackbar.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false,
              validationMessage: error.message
            })
          }
        );
    } else { // Edit
      this.userService.editUser(user)
        .then(
          (data) => {
            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setState({ isLoading: false })
            this.handleCloseAddEditUserModal();
          },
          error => {
            this.snackbar.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false,
              validationMessage: error.message
            });
          });
    }
  };

  handleCloseAddEditUserModal = () => {
    this.showEditDialog(false)
    this.setCurrentUser(new UserModel());
    this.getAllUsers(this.state.from, this.state.numberOfRows);
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  setCurrentUser(user: UserModel) {
    this.setState({ currentUser: { ...user } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;

    this.setState({
      numberOfRows: e.rows
    }, () => this.getAllUsers(startIndex, this.state.numberOfRows))
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.userService.getAllUsers(initFrom, numberOfRows, settings).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          users: data.users,
          userSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  public render() {

    const { users, isLoading, numberOfRows } = this.state;

    return (
      <div style={{ marginBottom: 50 }}>

        <h1>{Translate("Users")}</h1>

        {isLoading ? <Spinner /> : null}
        <Snackbar ref={(el) => this.snackbar = el} />

        {this.state.isVisibleDialogWrap ? (
          <UserAddEditDialog
            saveClick={this.handleSaveButton}
            closeAddEditUserModal={this.handleCloseAddEditUserModal}
            cancelClick={this.handleCancelButton}
            currentUser={this.state.currentUser}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <UserFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
        />

        {this.state.totalRecordsCount
          ? <UserList
            users={users}
            rows={numberOfRows}
            totalRecords={this.state.totalRecordsCount}
            onPageClick={this.handleOnPageClick}
            first={this.state.from}
            loading={Spinner}
            editClick={this.handleAddAndEditClick}
            deleteClick={this.handleDeleteClick}
          />
          : <div style={{ marginLeft: 10 }}>
            {Translate("NoRecordsFound")}
          </div>
        }

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
          <Button color="primary" variant="contained" style={{ marginRight: 10 }} onClick={() => this.handleAddAndEditClick(null)}>
            {Translate("Add")}
          </Button>
        </div>

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteUser(this.state.currentUser.userId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          {Translate("Are you sure that you want to delete")} "{this.state.currentUser.name}"?
        </ConfirmDialog>
      </div>
    );
  }
}

export default UserContainer;
